[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 13,
                "y": 22,
                "key": "tLpRoiW2EvVrLyND4pBYF"
            },
            {
                "x": 17,
                "y": 22,
                "key": "7gTwWqlCkIq9wxOI9wDMl"
            },
            {
                "x": 17,
                "y": 26,
                "key": "z9Nn61pWmpd489F0Co-yj"
            },
            {
                "x": 13,
                "y": 26,
                "key": "stOEn_4Hof8z7g2cDFKPY"
            }
        ]
    },
    {
        "key": "2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 13,
                "y": 17,
                "key": "soqLI"
            },
            {
                "x": 17,
                "y": 17,
                "key": "OQV7X"
            },
            {
                "x": 17,
                "y": 21,
                "key": "rKwfO"
            },
            {
                "x": 13,
                "y": 21,
                "key": "njcBm"
            }
        ]
    },
    {
        "key": "3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 13,
                "y": 12,
                "key": "emMlm"
            },
            {
                "x": 17,
                "y": 12,
                "key": "km1H9"
            },
            {
                "x": 17,
                "y": 16,
                "key": "6aNO7"
            },
            {
                "x": 13,
                "y": 16,
                "key": "wC7F8"
            }
        ]
    },
    {
        "key": "4",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 13,
                "y": 7,
                "key": "MQfQS"
            },
            {
                "x": 17,
                "y": 7,
                "key": "pX4a_"
            },
            {
                "x": 17,
                "y": 11,
                "key": "jRxlL"
            },
            {
                "x": 13,
                "y": 11,
                "key": "hMNIj"
            }
        ]
    }
]